import _ from "lodash";
import Grid from "@mui/material/Grid";
import React, { useState, useEffect } from "react";
import { Box } from "@mui/system";
import { IconButton, Typography } from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";
import { unicodeToString } from "../../../../Js/Common";
import CircleIcon from '@mui/icons-material/Circle';

const pathToParentMenu = ["root"];

const WwList = (props) => {
  const classes = useStyles();
  const [classnames, setClassnames] = useState("");

  useEffect(() => {
    // if (props.data && props.data.class) {
    //   setClassnames(props.data.class);
    // }
  }, [props.data]);

  return (
    <>
      {props.data && props.data.source && (
        <Grid container>
          <Grid item xs={12} >
            <ul className={classes.UListcss}>
              <li className={classes.Licss}>
                <IconButton sx={{}}><CircleIcon sx={{color:"#DB8829", fontSize: '1vw'}}/></IconButton>
                <span
                  sx={{ color: "primary.main", pl: 1  }}
                >
                  <div
                    className={classnames}
                    id={props.data.myId.self}
                    dangerouslySetInnerHTML={{
                      __html: unicodeToString(props.data.source),
                    }}
                    style={{display: props.initHide && props.initHide.indexOf(props.data.myId.self) > -1 ? 'none' : 'inline-block'}}
                  ></div>
                </span>
              </li>
            </ul>
          </Grid>
        </Grid>
      )}
    </>
  );
};
const useStyles = makeStyles({
  UListcss: {
    padding: 5,
    paddingLeft: 0,
    marginTop: 2,
    marginLeft: 10,
    marginRight: 10,
    marginBottom: 4,
    color: "#3f51b5",
    background: 'linear-gradient(to right, #f2f2f2 0%,#ffffff 100%)',
    // background: 'linear-gradient(to bottom, rgba(228,245,252,0.1) 0%,rgba(191,232,249,0.2) 50%,rgba(159,216,239,0.2) 51%,rgba(114,128,173,0.4) 100%)',
    // border: '1px solid #CCCCCC',
    borderRadius: 10,
    listStyle: 'none'
  },
  Licss: {
    paddingLeft: 10,
    fontWeight: '500',
    paddingTop: 4,
    paddingBottom: 4,
    display: 'flex',
    alignItems: 'center'
  },
});
export default WwList;
